/**
 * Compact relative-time formatter — for sync/activity surfaces.
 * Just now / 30s ago / 5m ago / 2h ago / Yesterday / 3d ago / May 23 / May 23, 2025
 */
export function formatRelative(input: string | number | Date | null | undefined): string {
  if (input == null) return '—'
  const ts = typeof input === 'number' ? input : new Date(input).getTime()
  if (Number.isNaN(ts)) return '—'
  const diffSec = Math.round((Date.now() - ts) / 1000)
  if (diffSec < 5) return 'Just now'
  if (diffSec < 60) return `${diffSec}s ago`
  const min = Math.round(diffSec / 60)
  if (min < 60) return `${min}m ago`
  const hr = Math.round(min / 60)
  if (hr < 24) return `${hr}h ago`
  const day = Math.round(hr / 24)
  if (day === 1) return 'Yesterday'
  if (day < 7) return `${day}d ago`
  const d = new Date(ts)
  const sameYear = d.getFullYear() === new Date().getFullYear()
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
  })
}
